import { styled, css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const buttonStyle = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: '32px',
	width: '32px',
	border: 'none',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	background: token('color.background.neutral.subtle'),
	cursor: 'pointer',
	'&:hover': {
		background: token('color.background.neutral.subtle.hovered'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TableContainer = styled.div({
	height: '100%',
	position: 'relative',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LoadingOverlay = styled.div({
	pointerEvents: 'none',
	position: 'absolute',
	top: '0',
	right: '0',
	bottom: '0',
	left: '0',
	display: 'flex',
	WebkitBoxAlign: 'center',
	alignItems: 'center',
	WebkitBoxPack: 'center',
	justifyContent: 'center',
	backgroundColor: token('elevation.surface.overlay'),
	opacity: token('opacity.loading'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const OverlaySpinnerContainer = styled.div({
	position: 'fixed',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PaginationSpinnerContainer = styled.div({
	width: '100%',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginTop: '30px',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginBottom: '30px',
	textAlign: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpaceItem = styled.div({
	width: '100%',
	height: '52px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: `0 ${token('space.150')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpaceLink = styled.a<{ 'data-styled-selector'?: string }>({
	width: '100%',
	height: '52px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	'&:hover': {
		textDecoration: 'none',
		cursor: 'pointer',
	},
});
const spaceDirectorySpaceLinkSelector = 'spaceDirectory.SpaceLink';
SpaceLink.defaultProps = {
	'data-styled-selector': spaceDirectorySpaceLinkSelector,
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconContainer = styled.div({
	position: 'absolute',
	right: token('space.150'),
	top: '10px',
	height: '32px',
	maxWidth: '120px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconPlaceholder = styled.div({
	height: '52px',
	width: '120px',
	flexShrink: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Row = styled.div<{ 'data-styled-selector'?: string }>({
	width: '100%',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	height: '52px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	position: 'relative',
	' --action-button-color': token('color.icon.accent.gray'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	[`&:hover, [data-styled-selector="${spaceDirectorySpaceLinkSelector}"]:focus &`]: {
		color: token('color.text'),
		backgroundColor: token('color.background.neutral.hovered'),
		textDecoration: 'none',
		'--action-button-color': token('color.icon.subtle'),
	},
});
const spaceDirectoryTableRowSelector = 'spaceDirectory.Table.Row';
Row.defaultProps = {
	'data-styled-selector': spaceDirectoryTableRowSelector,
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = styled.div({
	minWidth: '260px',
	width: '30%',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginLeft: '10px',
	color: token('color.text'),
	padding: token('space.075'),
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const MenuButton = styled.button<{ isOpen: boolean }>(buttonStyle, {
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	background: (props) => (props.isOpen ? token('color.background.neutral.subtle') : 'inherit'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&& svg': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		color: (props) => (props.isOpen ? token('color.icon') : token('color.icon.subtle')),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&:hover svg': {
		color: token('color.icon'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoriesContainer = styled.div({
	width: '70%',
	marginLeft: token('space.200'),
	overflow: 'hidden',
	position: 'relative',
	whiteSpace: 'nowrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Category = styled.button({
	padding: `${token('space.025')} ${token('space.075')}`,
	maxWidth: '180px',
	border: 'none',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	margin: token('space.050'),
	font: token('font.body'),
	background: token('color.background.neutral.subtle'),
	color: token('color.text'),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	cursor: 'pointer',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	[`[data-styled-selector="${spaceDirectoryTableRowSelector}"]:hover &, [data-styled-selector="${spaceDirectorySpaceLinkSelector}"]:focus &`]:
		{
			background: token('color.background.neutral'),
		},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&:hover': {
		background: token('color.background.neutral'),
	},
});
